'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

export default function NotFound() {
    const router = useRouter();

    const handleGoHome = () => {
        router?.push('/home');
    };

    const handleGoBack = () => {
        if (typeof window !== 'undefined') {
            window.history?.back();
        }
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-sanctuary p-4">
            <div className="noise-overlay" aria-hidden="true" />
            <div className="text-center max-w-md relative z-10">
                <div className="flex justify-center mb-6">
                    <h1 className="text-9xl font-black text-gold opacity-20">404</h1>
                </div>

                <h2 className="text-2xl font-black text-silver tracking-tight uppercase mb-2">Page Not Found</h2>
                <p className="text-silver-dim text-sm font-light mb-8">
                    The page you&apos;re looking for doesn&apos;t exist. Let&apos;s get you back!
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={handleGoBack}
                        className="inline-flex items-center justify-center gap-2 bg-vestment text-white px-6 py-3 font-mono text-[11px] tracking-widest uppercase hover:bg-vestment-light transition-colors duration-200"
                    >
                        <Icon name="ArrowLeftIcon" size={16} />
                        Go Back
                    </button>

                    <button
                        onClick={handleGoHome}
                        className="inline-flex items-center justify-center gap-2 border border-border-strong text-silver px-6 py-3 font-mono text-[11px] tracking-widest uppercase hover:border-gold hover:text-gold transition-colors duration-200"
                    >
                        <Icon name="HomeIcon" size={16} />
                        Back to Home
                    </button>
                </div>
            </div>
        </div>
    );
}